'use client'

import Image from 'next/image'

import { cn } from '@/legacy-src/lib/utils'

import { Heading } from '@/src/domains/design-system/components/Heading'
import { useCMSMenu } from '@/src/domains/cms-menus/hooks/useCMSMenu'
import { getCMSMenuItemHref } from '@/src/domains/cms-menus/utils/getCMSMenuItemHref'
import { HeaderSubNavigationLink } from '@/src/domains/header/components/Header/HeaderSubNavigationLink'

export const HeaderNavigationOther = () => {
  const { data } = useCMSMenu('other-menu')

  return (
    <div className="flex flex-col items-center laptop:flex-row">
      <Image
        priority
        sizes="368px"
        height={330}
        width={368}
        alt=""
        src={'/images/header/menu-content-photo.png'}
        className="mr-12 hidden rounded-[40px] laptop:block"
      />
      <div className="flex w-full flex-col gap-3 laptop:flex-row">
        {data.map(({ id, title, children }) => (
          <div
            key={id}
            className={cn('flex flex-col rounded-xl p-5 laptop:flex-1 laptop:bg-transparent laptop:p-0', {
              'bg-sand-100': id % 3 === 0,
              'bg-yellow-500': id % 3 === 1,
              'bg-blue-500': id % 3 === 2,
            })}
          >
            <Heading element="h3" variant="xl" className="mb-6 text-secondary">
              {title}
            </Heading>
            <nav className="flex flex-col gap-5">
              {children?.map((link) => (
                <HeaderSubNavigationLink key={link.id} href={getCMSMenuItemHref(link)} iconColor="primary">
                  {link.title}
                </HeaderSubNavigationLink>
              ))}
            </nav>
          </div>
        ))}
      </div>
    </div>
  )
}
